import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

const DIALOG_MAX_WIDTH = "650px";
const DIALOG_MAX_HEIGHT = "80vh";
const DIALOG_CONTENT_MAX_HEIGHT = `calc(${DIALOG_MAX_HEIGHT} - 120px)`;
const TAB_CONTENT_MIN_HEIGHT = "300px";
const PROMPT_EDITOR_HEIGHT = "180px";
const PROMPT_EDITOR_MIN_HEIGHT = "150px";
const KC_LISTBOX_MAX_HEIGHT = "400px";
const KC_COMBOBOX_MAX_WIDTH = "420px";

export const useStyles = makeStyles({
  dialogSurface: {
    maxWidth: DIALOG_MAX_WIDTH,
    maxHeight: DIALOG_MAX_HEIGHT,
  },
  dialogContent: {
    minHeight: "480px",
    maxHeight: DIALOG_CONTENT_MAX_HEIGHT,
    fontSize: designTokens.fontSize.sm,
  },
  tabContent: {
    minHeight: TAB_CONTENT_MIN_HEIGHT,
  },
  promptEditorWrapper: {
    "& > div > div:last-child > div[style]": {
      height: `${PROMPT_EDITOR_HEIGHT} !important`,
    },
    "& .ql-container": {
      height: `${PROMPT_EDITOR_HEIGHT} !important`,
      backgroundColor: designTokens.neutral.white,
      borderBottomLeftRadius: designTokens.borderRadius.md,
      borderBottomRightRadius: designTokens.borderRadius.md,
    },
    "& .ql-editor": {
      minHeight: PROMPT_EDITOR_MIN_HEIGHT,
    },
    "& .ql-toolbar": {
      backgroundColor: designTokens.neutral[100],
      borderTopLeftRadius: designTokens.borderRadius.md,
      borderTopRightRadius: designTokens.borderRadius.md,
    },
  },
  actionButtons: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: designTokens.spacing[2],
  },
  llmField: {
    marginTop: designTokens.spacing[4],
  },
  knowledgeComponentListbox: {
    maxHeight: `${KC_LISTBOX_MAX_HEIGHT} !important`,
    paddingRight: designTokens.spacing[2],
    paddingBottom: designTokens.spacing[2],
    overflowY: "auto",
    overflowX: "hidden",
  },
  knowledgeComponentCombobox: {
    maxWidth: KC_COMBOBOX_MAX_WIDTH,
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
  },
  comboboxOption: {
    color: designTokens.neutral[700],
  },
  navButtonHidden: {
    visibility: "hidden",
    pointerEvents: "none",
  },
  navButtonContainer: {
    position: "relative",
    width: designTokens.spacing[10],
    height: designTokens.spacing[10],
  },
  navButtonAbsolute: {
    position: "absolute",
    top: "0",
    left: "0",
  },
});
